import { createContext } from "react";

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  return <AuthContext.Provider value={null}>{children}</AuthContext.Provider>;
};
